export default "// Type your solution below\ntype parameter =\n  Set_ship_code of string\n| Go_to of string\n";